
  import {Component, Vue, Watch} from "vue-property-decorator";
  import {DestinationOrgcodename, ProgressBar} from "@/views/components";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import TableHeader from "./TableHeader.vue";
  import {date_day_add, parseTime} from "@/utils";
  import Enumerable from "linq";

  @Component({
    name: "PackagePrint",
    components: {
      DestinationOrgcodename,
      YtoTable,
      Form1,
      TableHeader,
      Scan,
      ProgressBar
    }
  })
  export default class extends Vue {
    @Watch("UnpackOrgName", {deep: false})
    oncurrentRowChanged(val: string) {
      if (val.length === 0) {
        this.inputModel.input_UnpackOrgName = "";
      }
    }

    private rowEdit(row, idx) {
      row.edit = true;
      this.$nextTick(() => {
        var input: any = this.$refs['mark' + idx];
        if (input) {
          input.focus();
        }
      });

      this.$forceUpdate()
    }

    private printCount = 0;
    private totalCount = 0;
    private tabSelectIndex = '0';

    private printCountDialogFormVisible = false;
    private printDetailDialogFormVisible = false;
    private form = {};
    private inputModel: inputDataModel_PackagePrint = {
      input_PackageName: "",
      input_UnpackOrgName: "",
      input_PrinterName: "",
      input_PackageType: "",
      input_ProductType: "",
      input_LatticeNo:"",
      input_PaperSize: "",
    };
    public loading = false;
    public unpackageNameOptions = [];
    public value = [];
    public list = [];
    public input_DateRange = [];
    public timeOptionRange: String = "";
    public pickerOptions = {
      onPick: time => {
        if (time.minDate && !time.maxDate) {
          this.timeOptionRange = time.minDate;
        }
        if (time.maxDate) {
          this.timeOptionRange = null;
        }
      },
      disabledDate: time => {
        let timeOptionRange: any = this.timeOptionRange;
        let secondNum = 6 * 60 * 60 * 24 * 1000;
        if (timeOptionRange) {
          return (
            time.getTime() > timeOptionRange.getTime() + secondNum ||
            time.getTime() < timeOptionRange.getTime() - secondNum
          );
        }
      }
    };

    public pickerOptions2 = {
      onPick: time => {
        if (time.minDate && !time.maxDate) {
          this.timeOptionRange = time.minDate;
        }
        if (time.maxDate) {
          this.timeOptionRange = null;
        }
      }
    };
    public printCountForm = {
      dateRange: []
    };
    public printDetailForm = {
      packageName: "",
      dateRange: []
    };
    public table1Loading = false;

    get submitPrintDisable() {
      var c = Enumerable.from(this.printedResultShowList);
      var b = !(c.any(f => f.ID && parseInt(f.countNum) > 0));
      console.log(`submitPrintDisable:${this.printedResultShowList.length}-${b}`);
      return b;
    }

    public remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          var orgs = obj_PackagePrint.getOrgCodeListByPage(10, 1, query);
          this.unpackageNameOptions = JSON.parse(orgs);
        }, 500);
      } else {
        this.unpackageNameOptions = [];
      }
    }

    mounted() {
      this.inputModel.input_PackageType = "QY";
      this.inputModel.input_ProductType = "普通";
      try {
        //注册查询打印数据回传
        obj_PackagePrint.regist_SearchPrintDataCallback(
          this.SearchPrintDataCallback
        );
        //注册查询打印结果数据回传
        // obj_PackagePrint.regist_SearchPrintedDataCallback(
        //   this.SearchPrintedDataCallback
        // );
        //注册回传打印数量
        obj_PackagePrint.regist_PrintedCountCallback(this.PrintedCountCallback);
      } catch (error) {
        console.log("包签打印界面:注册回调函数异常" + error);
      }

      this.GetAllPrinters();

      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
      var d1 = date_day_add(new Date(), -6);
      this.printDetailForm.dateRange[0] = d1 + ' 00:00:00';
      this.printDetailForm.dateRange[1] = parseTime(new Date(), '{y}-{m}-{d} 00:00:00');
      this.printCountForm.dateRange[0] = d1 + ' 00:00:00';
      this.printCountForm.dateRange[1] = parseTime(new Date(), '{y}-{m}-{d} 00:00:00');
    }

    private progressBarDialogTitle = "";

    private PrintedCountCallback(printLoadingData) {
      console.log("printLoadingData");
      console.log(printLoadingData);
      this.printCount = printLoadingData.printedCount;
      this.totalCount = printLoadingData.totalCount;
      this.proressBarDialogShow = printLoadingData.loadingEnable;
      this.progressBarDialogTitle = printLoadingData.title;
      if (!printLoadingData.loadingEnable) {
        // this.$refs.multipleTable.clearSelection();
        // this.$nextTick(() => {
        (this.$refs.multipleTable as Vue & {
          clearSelection: Function;
        }).clearSelection();

        var newArray = this.printedResultShowList.map(function (item) {
          return {
            countNum: "",
            ID: item.ID,
            Name: item.Name,
            Type: item.Type,
            UnpackOrgName: item.UnpackOrgName,
            UnpackOrgCode: item.UnpackOrgCode,
            Count: item.Count,
            edit: false
          };
        });
        this.printedResultShowList = newArray;
        // });
      }
    }

    private proressBarDialogShow = false;

    private SubmitPrintFunc() {
        obj_PackagePrint.submitPrint(this.inputModel, this.multipleSelection);
    }

    private progressBarFormCloseFunc() {
      console.log("关闭bar");
      // this.proressBarDialogShow = false;
    }

    public options = [
      {
        value: "",
        label: ""
      }
    ];

    private GetAllPrinters() {
      var printersStr = obj_PackagePrint.getAllPrinters();
      var printers = JSON.parse(printersStr);
      this.options = [];
      this.options = printers.map(item => {
        return {value: `${item}`, label: `${item}`};
      });
      if (this.options.length > 0) {
        this.inputModel.input_PrinterName = this.options[0].value;
      }
    }

    private SearchPrintDataCallback(printDatas) {
      debugger
      setTimeout(() => {
        debugger
        this.printedResultShowList = [];
        this.multipleSelection.forEach(element => {
          if (element.ID) {
            this.printedResultShowList.push({
              ID: element.ID,
              Name: element.Name,
              Type: element.Type,
              UnpackOrgName: element.UnpackOrgName,
              UnpackOrgCode: element.UnpackOrgCode,
              Count: element.Count,
              edit: false
            });
          }
        });
        var aaa = this.printedResultShowList;
        aaa.forEach(row => {
          this.$nextTick(() => {
            (this.$refs.multipleTable as Vue & {
              toggleRowSelection: Function;
            }).toggleRowSelection(row, true);
          });
        });

        for (let index = 0; index < printDatas.length; index++) {
          const element = printDatas[index];
          var result = this.FindIsExist(element);
          if (!result) {
            this.printedResultShowList.push({
              ID: element.ID,
              Name: element.Name,
              Type: element.Type,
              UnpackOrgName: element.UnpackOrgName,
              UnpackOrgCode: element.UnpackOrgCode,
              Count: "",
              edit: false
            });
          }
        }
        this.table1Loading = false;
      }, 500);
    }

    private FindIsExist(element) {
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const _element = this.multipleSelection[index];
        if (_element.ID == element.ID) {
          return true;
        }
      }
      return false;
    }

    private handelSelectPrintRow(selection, row) {
      this.multipleSelection = selection;
      console.log("handelSelectPrintRow");

      console.log(this.multipleSelection);
      console.log(row);

      row.edit = !row.edit;

      console.log(row.edit);
      this.$nextTick(() => {
        var el = document.getElementById("editinput" + row.index);
        this.selectElementContents(el);
        //   // var el = document.getElementById("editinput1");
        //   // this.selectElementContents(el);
        //   // this.$refsfocus();
      });
    }

    private loseFcous(row) {
      row.edit = false;
    }

    private cellClick(row) {
      row.seen = true;
    }

    private printedResultShowList = [
      // {
      //   ID: "",
      //   Name: "嘉峪关中转包-934",
      //   UnpackOrgName: "甘肃嘉峪关接驳点",
      //   Type: "汽运",
      //   edit: false,
      //   Count: "",
      //   UnpackOrgCode: ""
      // }
    ];
    public multipleSelection = [];

    public handleSelectionChange(val) {
      this.multipleSelection = val;
      // val.length == this.printedResultShowList.length ||
      if (val.length == 0) {
        console.log("00000000000000");
        for (let index = 0; index < this.printedResultShowList.length; index++) {
          this.printedResultShowList[index].edit = false;
        }
      }
    }

    private searchResultShowList = [];

    private getFormValue(element) {
      this.inputModel = element;
    }

    //获得焦点，选中文本
    private getInputFocus(event): void {
      event.currentTarget.select();
    }

    private config = config;

    public selectElementContents(el) {
      try {
        el.blur();
        el.focus();
      } catch (error) {
      }
    }

    public SearchPrintDataFunc() {
      this.countNumReadonly = false;
      this.table1Loading = true;
      setTimeout(() => {
        this.GetPackageListAsync()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }, 500);
    }

    public GetPackageListAsync() {
      return new Promise((resolve, reject) => {
        try {
          resolve("success"); // 成功
          var input_PackageNameValue = this.inputModel.input_PackageName;
          var PackageName = "";
          if (input_PackageNameValue.includes("\n")) {
            var valueArray = input_PackageNameValue.split("\n");
            valueArray.forEach(element => {
              if (element.length > 0) {
                // PackageName += element + ";";
                PackageName += element + ",";
              }
            });
            if (PackageName.length > 0) {
              PackageName = PackageName.substr(0, PackageName.length - 1);
            }
          } else {
            PackageName = input_PackageNameValue;
          }
          //通过js的内置对象JSON来进行数组对象的深拷贝
          var _obj = JSON.stringify(this.inputModel);

          var requestModel: inputDataModel_PackagePrint = JSON.parse(_obj);
          requestModel.input_PackageName = PackageName;
          obj_PackagePrint.getPackageList(requestModel);
        } catch (error) {
          reject("fail"); // 失败
        }
      });
    }

    private destinationorgdialogshow = false;

    public finddestinationorgcodename() {
      this.destinationorgdialogshow = true;
    }

    public UnpackOrgName = "";

    public destinationorgcodenameFunc(destinationorgModel) {
      this.destinationorgdialogshow = false;
      if (destinationorgModel != null) {
        console.log("destinationorgModel");
        console.log(destinationorgModel);
        this.UnpackOrgName = destinationorgModel.name;
        this.inputModel.input_UnpackOrgName = destinationorgModel.code;
      }
    }

    private clearlinecodename() {
    }

    private ResetFunc() {
      this.inputModel.input_PackageName = "";
      this.inputModel.input_UnpackOrgName = "";
      this.inputModel.input_PackageType = "QY";
      this.inputModel.input_ProductType = "普通";
      if (this.options.length > 0) {
        this.inputModel.input_PrinterName = this.options[0].value;
      }
    }

    private printGetHistoryDetailRequest: PrintGetHistoryDetailRequest = {
      downloadTime: "",
      expireTime: "",
      extend1: "",
      extend2: "",
      extend3: "",
      matOrgCode: "",
      packageName: "",
      packageType: "",
      printSequence: "",
      productType: "",
      takeApartOrgCode: "",
      takeApartOrgName: "",
      waybillNo: ""
    };

    private queryPrintDetails(): void {
      this.printGetHistoryDetailRequest.waybillNo = "";
      debugger
      if (this.printDetailForm.packageName) {
        var reg = new RegExp('\n', "g");
        this.printGetHistoryDetailRequest.waybillNo = this.printDetailForm.packageName.replace(reg, ',');
      }
      if (!this.printDetailForm.dateRange) {
        this.$message.error("请选择打印日期");
        return;
      }
      if (this.printDetailForm.dateRange.length === 0) {
        this.$message.error("请选择打印日期");
        return;
      }
      this.printGetHistoryDetailRequest.downloadTime = this.printDetailForm.dateRange[0];
      this.printGetHistoryDetailRequest.expireTime = this.printDetailForm.dateRange[1].replace('00:00:00', '23:59:59');
      var res = obj_PackagePrint.getPrintGetHistoryDetail(this.printGetHistoryDetailRequest);
      let apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> = JSON.parse(res);
      if (apiRes.respcode !== '000') {
        this.$message.error(apiRes.respMessage);
        return;
      }

      this.searchResultShowList = apiRes.data;
      this.tabSelectIndex = '1';
      this.printDetailDialogFormVisible = false;
    }

    private printGetHistoryNumRequest: PrintGetHistoryNumRequest = {
      downloadTime: "",
      expireTime: "",
      extend1: "",
      extend2: "",
      extend3: "",
      matOrgCode: "",
      packageName: "",
      packageType: "",
      printSequence: "",
      productType: "",
      takeApartOrgCode: "",
      takeApartOrgName: "",
      waybillNo: ""
    };

    private tabTableClick(tab): void {
      if (tab.name === '1') {
        this.printDetailDialogFormVisible = true
      }
    }

    private countNumReadonly = false;

    private queryHistoryNum() {
      this.countNumReadonly = true;
      this.printedResultShowList = [];
      this.printGetHistoryNumRequest.downloadTime = this.printCountForm.dateRange[0];
      this.printGetHistoryNumRequest.expireTime = this.printCountForm.dateRange[1].replace('00:00:00', '23:59:59');
      var res = obj_PackagePrint.getHistoryNum(this.printGetHistoryNumRequest);
      var apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> = JSON.parse(res);
      debugger
      if (apiRes.respcode === '000') {
        if (apiRes.data && apiRes.data.length) {
          for (let i = 0; i < apiRes.data.length; i++) {
            var e = apiRes.data[i];
            var item = {
              ID: "",
              Name: e.packageName,
              UnpackOrgName: e.takeApartOrgName,
              Type: e.packageType,
              edit: false,
              Count: 0,
              UnpackOrgCode: "",
              countNum: e.printSequence
            };
            this.printedResultShowList.push(item);
            var aaa = this.printedResultShowList;
            aaa.forEach(row => {
              this.$nextTick(() => {
                (this.$refs.multipleTable as Vue & {
                  toggleRowSelection: Function;
                }).toggleRowSelection(row, true);
              });
            });
          }
          this.printCountDialogFormVisible = false;
          this.tabSelectIndex = "0";
        } else {
          this.$message.warning('未查询到数据或历史打印记录已被清除')
        }
      }
    }
  }
